<template>
  <Link
    v-for="model in resource.data"
    :key="model.data.id"
    :class="{ active: options.active == model.data.id }"
    :href="route(`${routePrefix}.${resourceType}.show`, { id: model.data.id })"
    class="pill"
  >
    {{ model.data.attributes.name }}
  </Link>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import useResource from '@kanrisha/composables/useResource';

export default {
  components: {
    Link,
  },
  props: {
    options: { type: Object, default: () => {} },
    resource: { type: Object, default: () => {} },
    name: { type: String, default: 'default' },
    pagination: { type: Boolean, default: () => true }, // deprecated: this should go on options or config
  },
  emits: ['addToast', 'updatePicked', 'update:data', 'update:relation', 'trigger:refresh'],
  setup(props) {
    const { meta, resourceType } = useResource(props, props.resource);

    return {
      meta,
      resourceType,
    };
  },
};
</script>
